import { createContext, useContext, useState, useEffect } from 'react';

export const LOCALES = ['nl', 'fr', 'en'];

export const translations = {
  nl: {
    nav: { catalog: 'Producten', about: 'Over ons', login: 'Inloggen', logout: 'Uitloggen', register: 'Registreren', myAccount: 'Mijn account', admin: 'Admin' },
    catalog: { title: 'Onze producten', all: 'Alle', featured: 'Uitgelicht', search: 'Zoeken...', noResults: 'Geen producten gevonden' },
    product: { addToCart: 'In winkelmand', outOfStock: 'Uitverkocht', origin: 'Herkomst', usage: 'Gebruiksaanwijzing', sku: 'Artikelnummer', indications: 'Indicaties', composition: 'Samenstelling', warnings: 'Waarschuwingen' },
    common: { loading: 'Laden...', back: 'Terug', save: 'Opslaan', cancel: 'Annuleren' },
    precutover: {
      title: 'Binnenkort online bestellen',
      message: 'Onze nieuwe webshop wordt momenteel voorbereid. Online bestellen via deze website is binnenkort beschikbaar. Tot dan kunt u bestellen via onze huidige webshop.',
      cta: 'Naar onze huidige webshop',
      browse: 'Bekijk producten',
    },
    hero: { subtitle: 'Aquarius Age Company Belgium', title1: 'The', title2: 'Herborist', desc: 'Zorgvuldig geselecteerde botanische producten. Puur, krachtig en wetenschappelijk onderbouwd.', cta: 'Bekijk producten' },
    values: [
      { title: 'Puur & Biologisch', desc: 'Geen synthetische toevoegingen' },
      { title: 'Wetenschappelijk', desc: 'Onderbouwd door onderzoek' },
      { title: 'Professioneel', desc: 'Vertrouwd door zorgprofessionals' },
    ],
  },
  fr: {
    nav: { catalog: 'Produits', about: 'A propos', login: 'Connexion', logout: 'Deconnexion', register: "S'inscrire", myAccount: 'Mon compte', admin: 'Admin' },
    catalog: { title: 'Nos produits', all: 'Tous', featured: 'En vedette', search: 'Rechercher...', noResults: 'Aucun produit trouve' },
    product: { addToCart: 'Ajouter au panier', outOfStock: 'Epuise', origin: 'Origine', usage: 'Utilisation', sku: 'Reference', indications: 'Indications', composition: 'Composition', warnings: 'Avertissements' },
    common: { loading: 'Chargement...', back: 'Retour', save: 'Enregistrer', cancel: 'Annuler' },
    precutover: {
      title: 'Commande en ligne bientot disponible',
      message: 'Notre nouvelle boutique en ligne est en cours de preparation. Commander en ligne via ce site sera bientot possible. En attendant, vous pouvez commander via notre boutique actuelle.',
      cta: 'Vers notre boutique actuelle',
      browse: 'Voir les produits',
    },
    hero: { subtitle: 'Aquarius Age Company Belgium', title1: 'The', title2: 'Herborist', desc: 'Produits botaniques soigneusement selectionnes. Purs, puissants et scientifiquement fondes.', cta: 'Voir les produits' },
    values: [
      { title: 'Pur & Biologique', desc: 'Aucun additif synthetique' },
      { title: 'Scientifique', desc: 'Fonde sur la recherche' },
      { title: 'Professionnel', desc: 'Approuve par les professionnels de sante' },
    ],
  },
  en: {
    nav: { catalog: 'Products', about: 'About', login: 'Login', logout: 'Logout', register: 'Register', myAccount: 'My account', admin: 'Admin' },
    catalog: { title: 'Our products', all: 'All', featured: 'Featured', search: 'Search...', noResults: 'No products found' },
    product: { addToCart: 'Add to cart', outOfStock: 'Out of stock', origin: 'Origin', usage: 'Usage', sku: 'SKU', indications: 'Indications', composition: 'Composition', warnings: 'Warnings' },
    common: { loading: 'Loading...', back: 'Back', save: 'Save', cancel: 'Cancel' },
    precutover: {
      title: 'Online ordering coming soon',
      message: 'Our new webshop is currently being prepared. Online ordering through this website will be available soon. Until then, you can place your order via our current webshop.',
      cta: 'Go to our current webshop',
      browse: 'View products',
    },
    hero: { subtitle: 'Aquarius Age Company Belgium', title1: 'The', title2: 'Herborist', desc: 'Carefully selected botanical products. Pure, powerful, and scientifically grounded.', cta: 'View products' },
    values: [
      { title: 'Pure & Organic', desc: 'No synthetic additives' },
      { title: 'Scientific', desc: 'Backed by research' },
      { title: 'Professional', desc: 'Trusted by healthcare professionals' },
    ],
  },
};

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [locale, setLocale] = useState(() => localStorage.getItem('herborist_locale') || 'nl');

  useEffect(() => {
    localStorage.setItem('herborist_locale', locale);
  }, [locale]);

  return (
    <LanguageContext.Provider value={{ locale, setLocale }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  return useContext(LanguageContext);
}

export function useT() {
  const { locale } = useLanguage();
  return translations[locale] || translations.nl;
}

export function localise(obj, field, locale) {
  if (!obj) return '';
  return obj[`${field}_${locale}`] || obj[`${field}_nl`] || '';
}
